// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonPlaceholders = {
  enter: "请输入",
  select: "请选择",
} as const;
